import { lazy } from 'react'

import { PATH_NEW_LOADER } from 'config/paths'

export const PaymentsRoutes = [
    {
        id: 1,
        module: 'loader-payments',
        protected: false,
        exact: true,
        path: PATH_NEW_LOADER.pages.payments,
        component: lazy(
            () =>
                import(
                    // eslint-disable-next-line max-len
                    'containers/emulator/pages/payments/payments-page/PaymentsPage'
                ),
        ),
    },
    {
        id: 2,
        module: 'loader-payments',
        protected: false,
        exact: true,
        path: `${PATH_NEW_LOADER.pages.payments}/:id`,
        component: lazy(
            () =>
                import(
                    // eslint-disable-next-line max-len
                    'containers/emulator/pages/payments/payments-item/PaymentItem'
                ),
        ),
    },
]
